export const appVersion = '0.0.8';
export const appRevision = '0337545d587acb02a47ad742d069b687d9db06aa';



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/environments/version.ts